$('#pdqMoreOptions').on('click', function () {
    $('#pdqMoreOptionsPanel').toggle();
    $('#pdqProperties').toggle();
});